import React, { useEffect, useMemo } from 'react'
import {
  DescriptionField,
  DueDatePicker,
  ReminderSelector,
  StartDatePicker,
  StatusSelector,
  SubjectField,
  TypeSelector,
} from './Fields'
import { OwnerSelect } from '@user/components/Owner/OwnerSelect'
import { ActivityType } from '@user/features/Activity/ActivitiyTypes/typings'
import { IUserPosition } from '@user/store/salesTeam'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useFormikContext } from 'formik'
import { getHours, getMinutes, isBefore, set } from 'date-fns'

type Props = {
  activityTypes: ActivityType[]
  owners: IUserPosition[]
  salesTeamId: number
}

export function EditActivityFormFields(props: Props) {
  const { activityTypes, salesTeamId } = props

  const { values, setFieldValue, initialValues } = useFormikContext<any>()

  const { dueDate, dueTime } = values

  const isDueDateInPast = useMemo(() => {
    if (!dueDate || !dueTime) return false
    const due = set(new Date(dueDate), {
      hours: getHours(dueTime),
      minutes: getMinutes(dueTime),
    })
    const now = new Date()
    return isBefore(due, now)
  }, [dueDate, dueTime])

  useEffect(() => {
    if (isDueDateInPast && values.reminderThreshold !== 'None') {
      setFieldValue('reminderThreshold', 'None')
    }
  }, [
    isDueDateInPast,
    values.reminderThreshold,
    setFieldValue,
    initialValues.reminderThreshold,
  ])

  return (
    <Box>
      <Stack direction="column" p={0}>
        <Box>
          <SubjectField />
        </Box>
        <Box>
          <TypeSelector activityTypes={activityTypes} />
        </Box>
        <Box>
          <OwnerSelect
            salesTeamId={`${salesTeamId}`}
            label="Owner"
            margin="normal"
            name="ownerId"
            size="small"
            required
            useAdditionalMargin
            unassignedOption
            defaultSetRequired={false}
            testId="owner"
          />
        </Box>

        <Box>
          <StartDatePicker />
        </Box>
        <Box>
          <DueDatePicker />
        </Box>
        <Box>
          <ReminderSelector disabled={isDueDateInPast} />
        </Box>
        <Box>
          <DescriptionField />
        </Box>
        <Box>
          <StatusSelector />
        </Box>
      </Stack>
    </Box>
  )
}
